<template>
  <div class="ds-control dsf_teas_assess_iframe mobile">
    <iframe v-if="sourcesUrl" :src="sourcesUrl" frameborder="0" width="100%" height="100%"></iframe>
    <div v-else class="no-src">请配置评估列表地址</div>
  </div>
</template>

<script>


export default dsf.component({
  name: "DsfMobileTeasAssessIframe",
  ctrlCaption: "评估4.0",
  mixins: [$mixins.control],
  design: {
    isMask: false
  },
  props: {
    // 地址
    sourcesUrl: {
      type: String,
      default: "/dsfa/teasmobile/dist/webmobile/index.html#/business/teachEval?dsf5=1&titleName=课程评价",
    },
  },
  data() {
    return {
      activeIndex: 0,
      tabs: [],
      error: false
    };
  },

  components: {
  },

  mounted() {
  },

  created() {
    const arr = document.body.className.split(' ');
    const theme = arr.find(it => it.includes('-theme'));
    !!theme && sessionStorage.setItem('theme', theme);
  },

  methods: {
  }
});
</script>
